export default __webpack_public_path__ + "static/media/arrow_right.4749e039.svg";